module.exports = __webpack_public_path__ + "static/media/721JOSEPHEBOONEBLVD_2018-06-05_50.6cbcc73f.jpg";